import { render, staticRenderFns } from "./GlobalSpecsShow.vue?vue&type=template&id=53d4bf60&"
import script from "./GlobalSpecsShow.vue?vue&type=script&lang=js&"
export * from "./GlobalSpecsShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports